module.exports = __webpack_public_path__ + "img/biblioteca1.5484394d.jpg";